module.exports = __webpack_public_path__ + "img/SetupAddProduct19.753a3f09.png";